import { timesheetAPI } from '@/utils/api'

export default {
  namespaced: true,
  
  state: {
    checkInOutStatus: null,
    timesheetHistory: [],
    timesheetForApproval: [],
    loading: false,
    error: null
  },
  
  mutations: {
    SET_CHECK_IN_OUT_STATUS(state, status) {
      state.checkInOutStatus = status
    },
    SET_TIMESHEET_HISTORY(state, history) {
      state.timesheetHistory = history
    },
    SET_TIMESHEET_FOR_APPROVAL(state, timesheets) {
      state.timesheetForApproval = timesheets
    },
    ADD_TIMESHEET_RECORD(state, record) {
      state.timesheetHistory.unshift(record)
    },
    UPDATE_TIMESHEET_RECORD(state, updatedRecord) {
      const index = state.timesheetHistory.findIndex(record => record.DtrId === updatedRecord.DtrId)
      if (index !== -1) {
        state.timesheetHistory.splice(index, 1, updatedRecord)
      }
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  
  actions: {
    async checkInOut({ commit }, checkInOutData) {
      commit('SET_LOADING', true)
      
      try {
        const response = await timesheetAPI.mobileCheckInOut(checkInOutData)
        if (response.model) {
          commit('SET_CHECK_IN_OUT_STATUS', response.model)
        }
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async validateLocation({ commit }, locationData) {
      commit('SET_LOADING', true)
      
      try {
        const response = await timesheetAPI.validateLocation(locationData)
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async getLocationSettings({ commit }, employeeId) {
      commit('SET_LOADING', true)
      
      try {
        const response = await timesheetAPI.getLocationSettings(employeeId)
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async getInOutStatus({ commit }) {
      commit('SET_LOADING', true)
      
      try {
        const response = await timesheetAPI.mobileGetInOutStatus()
        if (response.model) {
          commit('SET_CHECK_IN_OUT_STATUS', response.model)
        }
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async getTimesheetHistory({ commit }, { fromDate, toDate }) {
      commit('SET_LOADING', true)
      
      try {
        const response = await timesheetAPI.mobileGetTimesheetHistory(fromDate, toDate)
        if (response.model) {
          commit('SET_TIMESHEET_HISTORY', response.model)
        }
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async getTimesheetForApproval({ commit }) {
      commit('SET_LOADING', true)
      
      try {
        const response = await timesheetAPI.mobileGetTimesheetForApproval()
        if (response.model) {
          commit('SET_TIMESHEET_FOR_APPROVAL', response.model)
        }
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async approveCheckInOut({ commit }, approvalData) {
      commit('SET_LOADING', true)
      
      try {
        const response = await timesheetAPI.mobileApproveCheckInOut(approvalData)
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async rejectCheckInOut({ commit }, rejectionData) {
      commit('SET_LOADING', true)
      
      try {
        const response = await timesheetAPI.mobileRejectCheckInOut(rejectionData)
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    async loadAttendanceDocuments({ commit }, { empId, shiftDate }) {
      commit('SET_LOADING', true)
      
      try {
        // Use the existing document API to load documents for attendance
        const { documentsAPI } = await import('@/utils/api')
        const response = await documentsAPI.getDocuments({
          proofType: 3, // Time Attendance
          referenceNo: `ATT_${empId}_${shiftDate.replace(/-/g, '')}_*`,
          userId: empId
        })
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    clearError({ commit }) {
      commit('SET_ERROR', null)
    }
  },
  
  getters: {
    checkInOutStatus: state => state.checkInOutStatus,
    timesheetHistory: state => state.timesheetHistory,
    timesheetForApproval: state => state.timesheetForApproval,
    loading: state => state.loading,
    error: state => state.error,
    canCheckIn: state => {
      if (!state.checkInOutStatus) return true
      return state.checkInOutStatus.NextStatus === 'CheckIn'
    },
    canCheckOut: state => {
      if (!state.checkInOutStatus) return false
      return state.checkInOutStatus.NextStatus === 'CheckOut'
    },
    todayRecords: state => {
      const today = new Date().toISOString().split('T')[0]
      return state.timesheetHistory.filter(record => 
        record.ShiftDate === today
      )
    },
    approvalCount: state => state.timesheetForApproval.length
  }
} 